import React, { useContext } from "react";
import { FaUserLarge } from "react-icons/fa6";
import { GoArrowUpRight } from "react-icons/go";
import { DataContext } from "../../context/DataContext";
import { format } from "date-fns";
import { Link } from "react-router-dom";

const BlogsList = () => {
  const dataContext = useContext(DataContext);

  const { blogs } = dataContext;

  let url = "https://admin.techqilla.com";

  return (
    <div className="py-6 sm:py-20 mx-4 sm:mx-12 flex flex-col gap-5 sm:gap-10 justify-center items-center">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 py-10">
        {blogs.map((blog) => (
          <Link
            to={`/blog/${blog.slug}`}
            onClick={() => window.scrollTo(0, 0)}
            state={{ blog }}
            id={blog.slug}
            className="w-full jost-regular rounded-xl flex flex-col max-w-[450px] mb-10"
          >
            <div className="p-2 rounded-xl">
              <div className="[&>img]:hover:scale-110 rounded-xl overflow-hidden [&>div]:hover:scale-110 relative">
                <img
                  className="object-none w-full transition-all duration-300 -z-10 h-[345px] rounded-xl"
                  src={`${url}${blog.cover.url}`}
                  alt={blog.title}
                />
                <div className="hover:bg-transparent rounded-xl transition duration-300 absolute bottom-0 top-0 right-0 left-0 bg-gray-900 opacity-25"></div>
                <a href="#!">
                  <div className="absolute bottom-4 right-0 bg-primary px-4 py-2 text-white mt-3 mr-3 hover:bg-white hover:text-primary transition rounded-lg flex flex-col items-center duration-500 ease-in-out">
                    <div className="text-2xl font-bold">
                      {format(new Date(blog.publishedAt), "dd")}
                    </div>
                    <div className="text-xs -mt-1">
                      {format(new Date(blog.publishedAt), "MMM")}
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex">
                <FaUserLarge className="text-primary text-xl" />
                <p className="text-base ml-2 opacity-50">
                  {blog.psyche_author.name}
                </p>
              </div>
              {/* <div className="flex justify-center items-center"> */}
              {/*   <FaCommentAlt className="text-primary text-lg" /> */}
              {/*   <p className="text-base ml-2 opacity-50">0 comments</p> */}
              {/* </div> */}
            </div>
            <hr className="my-4" />
            <h3 className="text-xl sm:text-2xl !font-jost-regular">
              {blog.title}
            </h3>
            <p className="opacity-80 my-4">{blog.description}</p>

            <div className="flex items-center cursor-pointer [&>svg]:hover:rotate-45 underline-offset-2 [&>div]:hover:text-black [&>svg]:hover:text-black transition-all duration-400">
              <div className="text-primary inter-regular text-lg underline pb-2">
                Read more
              </div>
              <GoArrowUpRight className="text-primary transition-all duration-300 p-1 text-2xl" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogsList;
